var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7328_16957)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7328_16957",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0L9.66885 0L9.66885 9.995L0.25 9.995L0.25 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7328_16957)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.155 4.672C8.155 4.904 7.9685 5.092 7.738 5.092L2.181 5.092C1.951 5.092 1.7645 4.904 1.7645 4.672L1.7645 1.59C1.7645 1.358 1.951 1.1695 2.181 1.1695L7.738 1.1695C7.9685 1.1695 8.155 1.358 8.155 1.59V4.672ZM7.5355 7.485H7.534C7.193 7.4825 6.919 7.2025 6.92099 6.859C6.9235 6.5155 7.202 6.239 7.542 6.24099C7.881 6.2435 8.155 6.521 8.155 6.863C8.154 7.207 7.8765 7.486 7.5355 7.485ZM2.395 7.485H2.394C2.053 7.4825 1.779 7.2025 1.78099 6.859C1.7835 6.5155 2.0615 6.239 2.402 6.24099C2.741 6.2435 3.0145 6.521 3.0145 6.863C3.014 7.207 2.7365 7.486 2.395 7.485ZM9.4495 2.98H9.1275V1.1695C9.1275 0.628 8.692 0.189 8.155 0.189L7.2645 0.189V0.1045C7.2645 0.047 7.2175 0 7.16 0L2.759 0C2.7015 0 2.655 0.047 2.655 0.1045V0.189L1.7645 0.189C1.2275 0.189 0.792 0.628 0.792 1.1695L0.792 2.98H0.47C0.3485 2.98 0.25 3.0785 0.25 3.2L0.25 4.092C0.25 4.2135 0.3485 4.312 0.47 4.312H0.792L0.792 7.656C0.7995 8.182 1.2285 8.602 1.75 8.5945H1.7645L1.7645 9.7155C1.7645 9.87 1.889 9.995 2.042 9.995H2.737C2.8905 9.995 3.0145 9.87 3.0145 9.7155L3.0145 8.5945L6.9045 8.5945V9.7155C6.9045 9.87 7.029 9.995 7.1825 9.995H7.877C8.0305 9.995 8.155 9.87 8.155 9.7155V8.53C8.6865 8.5175 9.115 8.0855 9.1275 7.5495L9.1275 4.312H9.4495C9.571 4.312 9.669 4.2135 9.669 4.092V3.2C9.669 3.0785 9.571 2.98 9.4495 2.98Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7328_16957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.6bead50e481303890274256de1cbd2ef.svg";
export { ForwardRef as ReactComponent };